<span class="status-dot status-dot-{{ enumStatus[state] }}" id="status-dot" title="{{statusTooltip$ | async}}"></span>
